import { Box, Chip, useTheme, type Theme } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { Filter } from "../../../../types/filter";

interface QuickFilterProps {
  filter: Filter;
  options?: Options[];
  onClick?: () => void;
  allowEmpty?: boolean;
}
type Options = {
  label: string;
  value: string;
};

const defaultOptions: Options[] = [
  { label: "All", value: "All" },
  { label: "Routes", value: "delivery_route" },
  { label: "Traps", value: "delivery_trap" },
];

const defaultChipStyle = (theme: Theme) => ({
  fontWeight: "400",
  borderRadius: "100px",
  height: "34px",
  border: 0,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.grey[300],
  padding: "0.5rem 10px",
  ".MuiChip-label": {
    padding: 0,
  },
  "&:hover": {
    backgroundColor: `${theme.palette.grey[400]} !important`,
  },
});

const activeChipStyle = (theme: Theme) => ({
  ...defaultChipStyle,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.grey[600],
  "&:hover": {
    backgroundColor: theme.palette.grey[800],
  },
});

const QuickFilter = ({
  filter,
  options = defaultOptions,
  onClick,
  allowEmpty,
}: QuickFilterProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const theme = useTheme();

  const activeChip = allowEmpty
    ? searchParams.get(filter.queryParam)
    : searchParams.get(filter.queryParam) || "All";

  const handleChipClick = (param?: string) => {
    const queryParam = filter.queryParam;

    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      newParams.set(queryParam, param ? param : "All");
      return newParams;
    });
    onClick?.();
  };

  return (
    <Box sx={{ display: "flex", gap: "8px", marginLeft: "15px" }}>
      {options.map(({ label, value }) => (
        <Chip
          key={value}
          label={label}
          size="medium"
          variant={activeChip === value ? "filled" : "outlined"}
          sx={
            activeChip === value
              ? activeChipStyle(theme)
              : defaultChipStyle(theme)
          }
          onClick={() => handleChipClick(String(value))}
        />
      ))}
    </Box>
  );
};

export default QuickFilter;
